import { Form, type FormInstance } from 'antd'
import { useLingui } from '@lingui/react/macro'

import useGetFormKeyPrefix from '../_hooks/useGetFormKeyPrefix'

import type {
  MusicGeneratorFormValuesNew,
  TaskType,
} from '@/pages/tad.ai/ai-music-generator/_types/form'

import StyleSelector from '@/pages/tad.ai/_components/StyleSelector'

interface DescriptionFormProps {
  form: FormInstance<MusicGeneratorFormValuesNew>
  taskType?: TaskType
  hideViewMore?: boolean
}
function DescriptionForm(props: DescriptionFormProps) {
  const { form, taskType: modalTaskType, hideViewMore } = props
  const { t } = useLingui()
  const formKeyPrefix = useGetFormKeyPrefix({ form })
  const descriptionFieldName = `${modalTaskType ? '' : formKeyPrefix}description`

  return (
    <div>
      <Form.Item
        name={descriptionFieldName} //modal模式下不需要formKeyPrefix
        className='mt-6'
        rules={[
          {
            validator(_, value) {
              if (
                !modalTaskType &&
                form.getFieldValue('styleMode') !== 'prompt'
              ) {
                return Promise.resolve()
              }
              if (!value) {
                return Promise.reject(
                  new Error(t`Please enter the prompt of the song`),
                )
              } else if (value.length > 300) {
                return Promise.reject(
                  new Error(t`Prompt cannot be longer than 300 characters`),
                )
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <StyleSelector
          maxLength={300}
          placeholder={t`Enter your prompt`}
          hideViewMore={hideViewMore}
        />
      </Form.Item>
    </div>
  )
}

export default DescriptionForm
